import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { MenuItem, Select, Tooltip, makeStyles } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import { isDisabledAllFieldCsv } from '../handler/KnowledgeUploadCsvHandler';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import DropDownUniqueKey from './DropDownUniqueKey';
import DropDownOverWriteAttachment from './DropDownOverWriteAttachment';
import DropDownOptionDelete from './DropDownOptionDelete';

export default function MappingForm({
    fieldListData,
    listMapping,
    setMapping,
    mapping,
    handleStatus,
    setIsEdited,
    setSelectedTypeImportCsv,
    selectedTypeImportCsv,
    selectedOptionKnowledgeId,
    setSelectedOptionKnowledgeId,
    listOptionsKnowledgeId,
    listUniqueField,
    selectedUniqueField,
    setSelectedUniqueField,
    selectedUniqueCsv,
    setSelectedUniqueCsv,
    selectedAttachFile,
    setSelectedAttachFile,
    enableAutoCreateNewTagItem,
    setEnableAutoCreateNewTagItem,

    selectDeleteMode,
    setSelectDeleteMode,

    selectDeleteKey,
    setSelectDeleteKey,
    listFieldInForm,

    selectCsvColumnName,
    setSelectCsvColumnName
}) {
    const handleChangeMapping = event => {
        let name = event.target.name;
        setMapping(prev => ({
            ...prev,
            [name]: event.target.value
        }));
        setIsEdited(true);
    };

    const useStyles = makeStyles(theme => ({
        dropdownStyle: {
            maxHeight: '200px',
            overflowY: 'auto'
        }
    }));

    const classes = useStyles();

    const handleChangeSelectedType = e => {
        setSelectedTypeImportCsv(e.target.value);
    };

    const handleChangeSettingAutoCreateTagItem = e => {
        setEnableAutoCreateNewTagItem(e.target.value);
    };

    return (
        <>
            <div className="mapping-wrapper line-wrapper-csv">
                <div className="options-import-csv">
                    <label className="label-upload-csv">{I18n.get('KNOWCRLB008')}</label>
                    <Select
                        fullWidth
                        className="form-control form-control--wrap"
                        select
                        disabled={isDisabledAllFieldCsv(handleStatus)}
                        variant="outlined"
                        value={selectedTypeImportCsv}
                        MenuProps={{
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left'
                            },
                            transformOrigin: {
                                vertical: 'top',
                                horizontal: 'left'
                            },
                            getContentAnchorEl: null
                        }}
                        onChange={handleChangeSelectedType}
                    >
                        <MenuItem
                            value={Constant.UPLOAD_CSV_KNOWLEDGE.TYPE_IMPORT_CSV.NO_OVERWRITE}
                        >
                            {I18n.get('DROPDOWN-NO-OVERWRITE')}
                        </MenuItem>
                        <MenuItem
                            value={Constant.UPLOAD_CSV_KNOWLEDGE.TYPE_IMPORT_CSV.KNOWLEDGE_ID}
                        >
                            {I18n.get('LABEL-KN-ID-CSV-COLUMN')}
                        </MenuItem>
                        <MenuItem
                            value={Constant.UPLOAD_CSV_KNOWLEDGE.TYPE_IMPORT_CSV.FIELD_OF_FORM}
                        >
                            <OverFlowTooltipWithTabsMui
                                value={I18n.get('LABEL-UNIQUE-KEY-FIELD-OF-FORM')}
                            />
                        </MenuItem>
                    </Select>
                </div>

                <DropDownUniqueKey
                    selectedTypeImportCsv={selectedTypeImportCsv}
                    selectedOptionKnowledgeId={selectedOptionKnowledgeId}
                    setSelectedOptionKnowledgeId={setSelectedOptionKnowledgeId}
                    listOptionsKnowledgeId={listOptionsKnowledgeId}
                    listUniqueField={listUniqueField}
                    selectedUniqueField={selectedUniqueField}
                    setSelectedUniqueField={setSelectedUniqueField}
                    selectedUniqueCsv={selectedUniqueCsv}
                    setSelectedUniqueCsv={setSelectedUniqueCsv}
                    handleStatus={handleStatus}
                />

                {/* select auto create tag */}
                 <div className="options-import-csv enable-auto-create-tag-item">
                    <label className="label-upload-csv">{'未登録タグの追加'}</label>
                    <Select
                        fullWidth
                        className="form-control form-control--wrap"
                        select
                        variant="outlined"
                        disabled={isDisabledAllFieldCsv(handleStatus)}
                        value={enableAutoCreateNewTagItem}
                        MenuProps={{
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left'
                            },
                            transformOrigin: {
                                vertical: 'top',
                                horizontal: 'left'
                            },
                            getContentAnchorEl: null
                        }}
                        onChange={handleChangeSettingAutoCreateTagItem}
                    >
                        <MenuItem
                            value={Constant.UPLOAD_CSV_KNOWLEDGE.AUTO_CREATE_TAG_ITEM.NOT_CREATE}
                        >
                            {'追加しない'}
                        </MenuItem>
                        <MenuItem value={Constant.UPLOAD_CSV_KNOWLEDGE.AUTO_CREATE_TAG_ITEM.CREATE}>
                            {'追加する'}
                        </MenuItem>
                    </Select>
                </div> 

                {/* delete-setting */}
                <DropDownOptionDelete
                    classes={classes}
                    handleStatus={handleStatus}
                    selectDeleteMode={selectDeleteMode}
                    setSelectDeleteMode={setSelectDeleteMode}
                    listMapping={listMapping}
                    selectDeleteKey={selectDeleteKey}
                    setSelectDeleteKey={setSelectDeleteKey}
                    listFieldInForm={listFieldInForm}
                    selectCsvColumnName={selectCsvColumnName}
                    setSelectCsvColumnName={setSelectCsvColumnName}
                    listOptionsKnowledgeId={listOptionsKnowledgeId}
                />
            </div>

            {selectedTypeImportCsv !==
                Constant.UPLOAD_CSV_KNOWLEDGE.TYPE_IMPORT_CSV.NO_OVERWRITE && (
                <div className="mapping-wrapper line-wrapper-csv">
                    <DropDownOverWriteAttachment
                        selectedAttachFile={selectedAttachFile}
                        setSelectedAttachFile={setSelectedAttachFile}
                        handleStatus={handleStatus}
                    />
                </div>
            )}

            <div className="mapping-wrapper line-wrapper-csv">
                <label className="label-upload-csv">{I18n.get('KNOWCRLB009')}</label>

                <div className="nameColumn-mapping">
                    <label className="label-nameField">{I18n.get('KNOWCRLB010')}</label>
                    <div className="title">{I18n.get('KNOWCRLB011')}</div>
                </div>

                {fieldListData?.map(field => (
                    <div className="fieldName-cloumn" key={`${field?.id}_field`}>
                        <div className="cell-prod-status gap-8">
                            <OverFlowTooltipWithTabsMui
                                className="label-nameField"
                                value={
                                    field.fieldLabel
                                        ? Utils.getTextByLanguage(
                                              Constant.LANGUAGE_TYPE.JP,
                                              field.fieldLabel
                                          )
                                        : ''
                                }
                            />
                            <Tooltip title={field.id} placement='top' arrow>
                                <img
                                    src="/assets/image/icon-copy.svg"
                                    alt="copy"
                                    onClick={() => navigator.clipboard.writeText(field.id)}
                                />
                            </Tooltip>
                        </div>
                        <Select
                            disabled={isDisabledAllFieldCsv(handleStatus)}
                            fullWidth
                            displayEmpty
                            className="form-control form-control--wrap"
                            select
                            variant="outlined"
                            defaultValue={0}
                            value={mapping[field.id] ? mapping[field.id] : 0}
                            inputProps={{
                                name: field.id,
                                id: field.id
                            }}
                            onChange={handleChangeMapping}
                            MenuProps={{
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                },
                                transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'left'
                                },
                                classes: { paper: classes.dropdownStyle },
                                getContentAnchorEl: null
                            }}
                        >
                            {listMapping?.map((item, index) => (
                                <MenuItem value={item.key} key={`${item.key}_mapping_${index}`}>
                                    <OverFlowTooltipWithTabsMui
                                        value={item.value}
                                        className="mapping-item"
                                    />
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                ))}
            </div>
        </>
    );
}
